(function () {
  function createMessage(content, role) {
    var item = document.createElement("div");
    item.className = "sf-ai-chat__message sf-ai-chat__message--" + role;
    item.textContent = content;
    return item;
  }

  function createProductsList(products) {
    var list = document.createElement("div");
    list.className = "sf-ai-chat__products";

    products.forEach(function (product) {
      var card = document.createElement(product && product.url ? "a" : "article");
      card.className = "sf-ai-chat__product";
      if (product && product.url) {
        card.href = product.url;
        card.target = "_blank";
        card.rel = "noopener noreferrer";
      }

      var image = document.createElement("div");
      image.className = "sf-ai-chat__product-image";
      if (product && product.image) {
        image.style.backgroundImage = "url('" + String(product.image).replace(/'/g, "\\'") + "')";
        image.style.backgroundSize = "cover";
        image.style.backgroundPosition = "center";
      } else {
        image.setAttribute("aria-hidden", "true");
      }

      var body = document.createElement("div");
      var name = document.createElement("p");
      name.className = "sf-ai-chat__product-name";
      name.textContent = product && product.name ? String(product.name) : "Product";

      var meta = document.createElement("p");
      meta.className = "sf-ai-chat__product-meta";
      meta.textContent = product && product.meta ? String(product.meta) : "";

      body.appendChild(name);
      body.appendChild(meta);

      var price = document.createElement("span");
      price.className = "sf-ai-chat__product-price";
      price.textContent = product && product.price ? String(product.price) : "";

      card.appendChild(image);
      card.appendChild(body);
      card.appendChild(price);
      list.appendChild(card);
    });

    return list;
  }

  function renderAssistantPayload(parsed, assistantMessage) {
    revealAssistantMessage(assistantMessage);
    assistantMessage.textContent = "";

    var replyText =
      (typeof parsed.reply === "string" && parsed.reply.trim()) ||
      (typeof parsed.message === "string" && parsed.message.trim()) ||
      (typeof parsed.text === "string" && parsed.text.trim()) ||
      "";

    if (replyText) {
      assistantMessage.appendChild(document.createTextNode(replyText));
    }

    if (parsed && Array.isArray(parsed.products) && parsed.products.length > 0) {
      if (replyText) {
        assistantMessage.appendChild(document.createElement("br"));
      }
      assistantMessage.appendChild(createProductsList(parsed.products));
    }

    appendSources(assistantMessage, parsed);
    return Boolean(replyText || (parsed.products && parsed.products.length));
  }

  function createThinkingMessage() {
    var item = document.createElement("div");
    item.className = "sf-ai-chat__message sf-ai-chat__message--assistant sf-ai-chat__message--thinking";
    item.innerHTML =
      'thinking<span class="sf-ai-chat__thinking-dots" aria-hidden="true"><i></i><i></i><i></i></span>';
    return item;
  }

  function appendSources(assistantMessage, parsed) {
    if (!parsed || !Array.isArray(parsed.sources) || parsed.sources.length === 0) {
      return;
    }

    var validSources = parsed.sources
      .filter(function (source) {
        return source && (source.title || source.url);
      })
      .slice(0, 3);

    if (validSources.length === 0) {
      return;
    }

    assistantMessage.appendChild(document.createElement("br"));
    var label = document.createElement("span");
    label.className = "sf-ai-chat__sources-label";
    label.textContent = "Sources: ";
    assistantMessage.appendChild(label);

    validSources.forEach(function (source, index) {
      var link = document.createElement("a");
      link.className = "sf-ai-chat__source-link";
      link.textContent = source.title || source.url;
      if (source.url) {
        link.href = source.url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
      }
      assistantMessage.appendChild(link);
      if (index < validSources.length - 1) {
        assistantMessage.appendChild(document.createTextNode(" • "));
      }
    });
  }

  function revealAssistantMessage(assistantMessage) {
    if (assistantMessage.classList.contains("sf-ai-chat__message--thinking")) {
      assistantMessage.classList.remove("sf-ai-chat__message--thinking");
      assistantMessage.textContent = "";
    }
  }

  function parseSseLine(line, assistantMessage) {
    if (!line || line.indexOf("data:") !== 0) {
      return;
    }

    var payload = line.slice(5).trim();
    if (!payload || payload === "[DONE]") {
      return;
    }

    try {
      var parsed = JSON.parse(payload);
      if (renderAssistantPayload(parsed, assistantMessage)) {
        return;
      }

      if (typeof parsed === "string") {
        revealAssistantMessage(assistantMessage);
        assistantMessage.textContent += parsed;
        return;
      }

      if (typeof parsed.text === "string") {
        revealAssistantMessage(assistantMessage);
        assistantMessage.textContent += parsed.text;
        appendSources(assistantMessage, parsed);
        return;
      }

      if (typeof parsed.delta === "string") {
        revealAssistantMessage(assistantMessage);
        assistantMessage.textContent += parsed.delta;
      }
    } catch (error) {
      revealAssistantMessage(assistantMessage);
      assistantMessage.textContent += payload;
    }
  }

  function getOrCreateSessionId() {
    var key = "sf-ai-chat-session-id";
    try {
      var current = window.localStorage.getItem(key);
      if (current) {
        return current;
      }
      var generated =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : "sf-" + Date.now() + "-" + Math.random().toString(16).slice(2);
      window.localStorage.setItem(key, generated);
      return generated;
    } catch (error) {
      return "sf-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    }
  }

  function buildContextPayload(root) {
    return {
      sessionId: getOrCreateSessionId(),
      url: window.location.href,
      pathname: window.location.pathname,
      title: document.title,
      referrer: document.referrer || "",
      locale: root.dataset.locale || document.documentElement.lang || "en",
      currency: root.dataset.currency || "",
      pageType: root.dataset.pageType || "",
      shopDomain: root.dataset.shopDomain || "",
      product:
        root.dataset.productTitle || root.dataset.productHandle
          ? {
              title: root.dataset.productTitle || "",
              handle: root.dataset.productHandle || "",
              vendor: root.dataset.productVendor || "",
              price: root.dataset.productPrice || ""
            }
          : null
    };
  }

  async function streamReply(endpoint, text, assistantMessage, contextPayload) {
    var response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream, application/json"
      },
      body: JSON.stringify({
        message: text,
        context: contextPayload
      })
    });

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    var contentType = response.headers.get("Content-Type") || "";
    if (contentType.indexOf("text/event-stream") === -1 || !response.body) {
      var json = await response.json();
      if (renderAssistantPayload(json, assistantMessage)) {
        return;
      }
      revealAssistantMessage(assistantMessage);
      assistantMessage.textContent = json.reply || json.message || "I did not get a response.";
      appendSources(assistantMessage, json);
      return;
    }

    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = "";

    while (true) {
      var chunk = await reader.read();
      if (chunk.done) {
        break;
      }

      buffer += decoder.decode(chunk.value, { stream: true });
      var lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (var i = 0; i < lines.length; i += 1) {
        parseSseLine(lines[i], assistantMessage);
      }
    }

    if (!assistantMessage.textContent.trim()) {
      revealAssistantMessage(assistantMessage);
      assistantMessage.textContent = "No response returned.";
    }
  }

  function init(root) {
    var toggle = root.querySelector("[data-chat-toggle]");
    var panel = root.querySelector("[data-chat-panel]");
    var close = root.querySelector("[data-chat-close]");
    var form = root.querySelector("[data-chat-form]");
    var input = root.querySelector(".sf-ai-chat__input");
    var messages = root.querySelector("[data-chat-messages]");
    var send = root.querySelector(".sf-ai-chat__send");
    if (!toggle || !panel || !close || !form || !input || !messages || !send) {
      return;
    }
    var endpoint =
      root.dataset.endpoint ||
      (window.StorefrontAIAgentConfig && window.StorefrontAIAgentConfig.endpoint) ||
      "/apps/storefront-ai-agent/chat";
    var welcome =
      root.dataset.welcome ||
      (window.StorefrontAIAgentConfig && window.StorefrontAIAgentConfig.welcomeMessage) ||
      "Hi, how can I help you shop today?";

    var hasWelcome = false;

    panel.hidden = true;
    root.dataset.typing = "false";
    toggle.setAttribute("aria-expanded", "false");

    function openPanel() {
      panel.hidden = false;
      root.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      if (!hasWelcome) {
        messages.appendChild(createMessage(welcome, "assistant"));
        hasWelcome = true;
      }
      input.focus();
    }

    function closePanel() {
      panel.hidden = true;
      root.classList.remove("is-open");
      panel.style.setProperty("--sf-tilt-x", "0deg");
      panel.style.setProperty("--sf-tilt-y", "0deg");
      toggle.setAttribute("aria-expanded", "false");
      toggle.focus();
    }

    toggle.addEventListener("click", function () {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    close.addEventListener("click", closePanel);

    input.addEventListener("input", function () {
      if (input.value.trim().length > 0) {
        root.dataset.typing = "true";
      } else {
        root.dataset.typing = "false";
      }
    });

    document.addEventListener("pointerdown", function (event) {
      if (panel.hidden) {
        return;
      }
      if (!root.contains(event.target)) {
        closePanel();
      }
    });

    panel.addEventListener("pointermove", function (event) {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }
      var rect = panel.getBoundingClientRect();
      var nx = (event.clientX - rect.left) / rect.width - 0.5;
      var ny = (event.clientY - rect.top) / rect.height - 0.5;
      var tiltX = ny * -2.2;
      var tiltY = nx * 2.2;
      panel.style.setProperty("--sf-tilt-x", tiltX.toFixed(2) + "deg");
      panel.style.setProperty("--sf-tilt-y", tiltY.toFixed(2) + "deg");
    });

    panel.addEventListener("pointerleave", function () {
      panel.style.setProperty("--sf-tilt-x", "0deg");
      panel.style.setProperty("--sf-tilt-y", "0deg");
    });

    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      var text = input.value.trim();
      if (!text) {
        return;
      }

      messages.appendChild(createMessage(text, "user"));
      input.value = "";
      root.dataset.typing = "false";

      var assistantMessage = createThinkingMessage();
      messages.appendChild(assistantMessage);
      messages.scrollTop = messages.scrollHeight;

      root.dataset.busy = "true";
      send.disabled = true;
      input.disabled = true;

      try {
        var contextPayload = buildContextPayload(root);
        await streamReply(endpoint, text, assistantMessage, contextPayload);
      } catch (error) {
        revealAssistantMessage(assistantMessage);
        assistantMessage.textContent = "I could not connect to the AI agent right now.";
      } finally {
        root.dataset.busy = "false";
        send.disabled = false;
        input.disabled = false;
        input.focus();
        messages.scrollTop = messages.scrollHeight;
      }
    });
  }

  document.querySelectorAll("[data-storefront-ai-agent]").forEach(init);
})();
